export const ASSET_KEYWORDS = {
  UPLOAD_ITEM: "PRODUCT_IMG",
  UPLOAD_INSTRUCTIONS: "PRODUCT_LIST",
  CUSTOM_PROMO_TEXT: "COPY_TEXT",
  THANKYOU_TEXT: "THANKYOU_TEXT",
  THANKYOU2_TEXT: "THANKYOU2_TEXT",
}
